export default __webpack_public_path__ + "static/media/mg.57832c73.jpg";